module.exports = __webpack_public_path__ + "static/media/social-icon-x-blue.749f5772.svg";